import Button from "../../../../../../common/components/atom/Button/Button";
import SelectInput from "../../../../../../common/components/atom/SelectInput/SelectInput";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import MessageCard from "../../../../../../common/components/molecule/MessageCard/MessageCard";
import {
  OrganizationFormData,
  OrganizationFormErrorStatus,
} from "../NewOrganizationFormPresenter";
import styles from "./NewOrganizationFormView.module.scss";

export interface NewOrganizationFormViewProps {
  organizationFormData?: OrganizationFormData;
  setOrganizationFormData: (organizationFormData: OrganizationFormData) => void;
  errorStatus?: OrganizationFormErrorStatus;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
}

/**
 * NewOrganizationFormView
 * 
 * @param param0 
 * @returns 
 */
export default function NewOrganizationFormView({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Créer",
  description = "Saisissez les informations de votre organisation",
  maxWidth = "700px",
  title,
  organizationFormData,
  setOrganizationFormData
}: NewOrganizationFormViewProps) {
  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Nom de l'organisation*"
              value={organizationFormData?.name}
              error={errorStatus?.isErrorName}
              onChange={(e) => {setOrganizationFormData({...organizationFormData, name: e.target.value})}}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
          <SelectInput
              label= "Devise"
              value={organizationFormData?.currency}
              error={errorStatus?.isCurencyError}
              handleChange={(value) => {
                setOrganizationFormData({
                  ...organizationFormData,
                  currency: value,
                });
              }}
  
              options={[
                { value: "FCFA", label: "FCFA" },

              ]}
            />
          </div>
          <h2 className={[styles["form__intersection-name"]].join(" ")}>
            Adresse
          </h2>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="N°, rue, avenue, etc."
              value={organizationFormData?.street}
              error={errorStatus?.isErrorStreet}
              onChange={(e) => {setOrganizationFormData({...organizationFormData, street: e.target.value})}}
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Ville"
              value={organizationFormData?.city}
              error={errorStatus?.isErrorCity}
              onChange={(e) => {setOrganizationFormData({...organizationFormData, city: e.target.value})}}
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Code postal"
              value={organizationFormData?.zip_code}
              error={errorStatus?.isErrorZipCode}
              onChange={(e) => {setOrganizationFormData({...organizationFormData, zip_code: e.target.value})}}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Pays"
              value={organizationFormData?.country}
              error={errorStatus?.isErrorCountry}
              onChange={(e) => {setOrganizationFormData({...organizationFormData, country: e.target.value})}}
            />
          </div>

          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
